export default __webpack_public_path__ + "static/media/OpenSans-Light.6d0ca57e.ttf";